"use client";
import React, { useState, useEffect, useRef, useCallback } from "react";
import Link from "next/link";
import StudentForm from "../components/StudentForm";
import ThankyouForm from "../components/ThankyouForm";
import Nav from "../components/Nav";
import RefreshForm from '../components/RefreshForm'; 

export default function RegistrationPage() {
  return (
    <main style={{ minHeight: "100vh", background: "#fffbf5", fontFamily: "'Segoe UI', system-ui, sans-serif" }}>

      {/* ── Notebook-paper texture strip at top ── */}
      <div style={{
        height:       8,
        background:   "repeating-linear-gradient(90deg, #fbbf24 0px, #fbbf24 2px, transparent 2px, transparent 32px)",
        borderBottom: "3px solid #f59e0b",
      }} />

      {/* ── Nav — fixed click structure and pathing ── */}
      <Nav style={{
        display:        "flex",
        alignItems:     "center",
        justifyContent: "space-between",
        padding:        "16px 40px",
        background:     "#fff",
        borderBottom:   "2px solid #fde68a",
        position:       "sticky",
        top:            0,
        zIndex:         100,
        boxShadow:      "0 2px 8px rgba(251,191,36,0.12)",
      }}>
        {/* 🌟 FIXED: Link is now inside <Nav> wrapping only the clickable logo assets */}
        <Link href="/" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{
            width:          38,
            height:         38,
            borderRadius:   10,
            background:     "linear-gradient(135deg, #f97316, #fbbf24)",
            display:        "flex",
            alignItems:     "center",
            justifyContent: "center",
            fontSize:       20,
            boxShadow:      "0 3px 0 #ca8a04",
          }}>📋</div>
          <div>
            <div style={{ fontSize: 22, fontWeight: 900, color: "#dc2626", letterSpacing: "-0.5px", lineHeight: 1.1 }}>
              #ClearTheList
            </div>
            <div style={{ fontSize: 11, fontWeight: 700, color: "#f97316", letterSpacing: "0px", textTransform: "uppercase" }}>
              For Teachers
            </div>
          </div>
        </Link>

        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {/* 🌟 FIXED: Force explicit origin path parsing using standard string targets */}
          <Link href="/#how-it-works" style={{ fontSize: 14, fontWeight: 600, color: "#64748b", textDecoration: "none" }}>
            How it Works
          </Link>
          <Link href="/#map" style={{ fontSize: 14, fontWeight: 600, color: "#64748b", textDecoration: "none" }}>
            Support a Classroom
          </Link>
          <Link href="/registration">
            <button className="bg-amber-400 hover:bg-amber-500 text-amber-950 font-bold py-2 px-7 rounded-full shadow-[0_4px_0_0_#ca8a04] active:translate-y-1 active:shadow-none transition-all">
              Submit a List ✏️
            </button>
          </Link>
        </div>
      </Nav>

      {/* ── Page hero ── */}
      <section style={{
        padding:    "48px 40px 0",
        background: "linear-gradient(160deg, #fffbf5 0%, #fff7ed 60%, #fef3c7 100%)",
        position:   "relative",
        overflow:   "hidden",
      }}>
        {/* Notebook ruled lines */}
        {[...Array(6)].map((_, i) => (
          <div key={i} style={{
            position:      "absolute",
            left:          0,
            right:         0,
            top:           60 + i * 40,
            height:        1,
            background:    "rgba(147,197,253,0.25)",
            pointerEvents: "none",
          }} />
        ))}
        {/* Red margin line */}
        <div style={{
          position:      "absolute",
          left:          96,
          top:           0,
          bottom:        0,
          width:         2,
          background:    "rgba(252,165,165,0.4)",
          pointerEvents: "none",
        }} />

        <div style={{ maxWidth: 600, margin: "0 auto", textAlign: "center", position: "relative" }}>

          <h1 style={{
            fontSize:      "clamp(28px, 4vw, 42px)",
            fontWeight:    900,
            color:         "#1e293b",
            lineHeight:    1.2,
            marginBottom:  12,
            letterSpacing: "-0.5px",
          }}>
            Get your classroom<br />
            <span style={{ color: "#dc2626", textShadow: "2px 2px 0 #fbbf24" }}>
              what it deserves
            </span>
          </h1>

          <p style={{
            fontSize:     16,
            color:        "#64748b",
            lineHeight:   1.7,
            marginBottom: 0,
            maxWidth:     480,
            margin:       "0 auto",
          }}>
            Fill out the form below and your wishlist will appear on our map
            so donors across the country can support your classroom directly.
          </p>
        </div>
      </section>

      {/* ── The form itself ── */}
      <div className="flex flex-col md:flex-row gap-8 md:gap-16 justify-center items-center md:items-start w-full px-4">
        <div className="w-full md:w-[400px]">
          <StudentForm />
        </div>
        <div className="w-full md:w-[400px]">
          <RefreshForm />
        </div>
      </div>
      
      {/* ── Footer ── */}
      <footer style={{
        background: "#1e293b",
        padding:    "32px 40px",
        textAlign:  "center",
      }}>
        <div style={{ fontSize: 22, fontWeight: 900, color: "#fbbf24", marginBottom: 8 }}>
          #ClearTheList
        </div>
        <div style={{ fontSize: 13, color: "#64748b" }}>
          info@clearthelist.org
        </div>
      </footer>

    </main>
  );
}